export const playbackSessionActions = {
  START: 'START',
  QUESTION_START: 'QUESTION_START',
  QUESTION_END: 'QUESTION_END',
  QUESTION_SCORE: 'QUESTION_SCORE',
  END: 'END',
};
